import { routes } from "@/configs/navlink.config";
import Link from "next/link";
import React from "react";
import { Col, Row } from "react-bootstrap";
import Ball from "@/assets/svg/ball.svg";
import Image from "next/image";
import styles from "@/styles/portfolio.module.scss";
import { BiRightArrowAlt } from "react-icons/bi";

const TeamMain = () => {
  return (
    <>
      <Row className='my-20'>
        <Col md={10} className='mx-auto bg-dark mt-10'>
          <Row>
            <Col xs={11} className='mx-auto pb-5'>
              <Image src={Ball} alt='ball' className={`mx-auto w-100 ${styles.ball}`} />
              <h1 className='bold mt-5 text-center'>
                Executive Team:
                <br /> Pioneers of <span className='text-gradient'>Metachain Technologies</span>
              </h1>
              <Row className='mt-5' as={"section"}>
                <h1 className='bold fs-3'>Steering Metachain to Global Eminence</h1>
                <p>
                  At Metachain Technologies, our leadership is the cornerstone of our success,
                  supported with professional team. With a blend of unparalleled expertise and
                  visionary leadership, our executive team charts the course for technological
                  innovation and business excellence.
                </p>
              </Row>
              <Row className='mt-5' as={"section"}>
                <h2 className='bold fs-4'>Matthew Connelly - The Visionary CEO</h2>
                <p>
                  Matthew Connelly is not just the CEO of Metachain; he's the embodiment of its
                  vision and ethos. With over two decades in the software development and digital
                  marketing sectors, Matthew's leadership is characterized by foresight and
                  adaptability. His early adoption of blockchain technology showcases his ability to
                  anticipate industry shifts and position Metachain at the forefront of innovation.
                </p>
                <p>
                  Matthew's unwavering commitment to the digital asset realm, from NFTs to the
                  metaverse, drives Metachain's mission. His strategic approach ensures that the
                  company remains a pioneer in integrating these groundbreaking technologies into
                  enterprise operations.
                </p>
                <p>
                  Beyond his technical prowess, Matthew's leadership style fosters a culture of
                  innovation, inspiring the Metachain team to explore new frontiers in the digital
                  asset domain. His reputation as an industry thought leader is well-earned, with a
                  track record of identifying trends and capitalizing on untapped opportunities.
                </p>
                <Link
                  className='d-flex hero-action gap-2 justify-content-center mt-3'
                  href={routes.mathew}
                >
                  <button className='btn btn-primary home-btn'> Read More About Matthew</button>
                  <span className='arr-right-btn d-flex align-items-center justify-content-center position-relative'>
                    <BiRightArrowAlt />
                    <BiRightArrowAlt className='position-absolute' />
                  </span>
                </Link>
              </Row>
              <Row className='mt-5' as={"section"}>
                <h2 className='bold fs-4'>Anas Madi - The Technological Maestro</h2>
                <p>
                  Anas Madi, our esteemed CTO, is an idol of technical brilliance and transformative
                  leadership. Leading a formidable team of over 100 professionals, Anas Madi's
                  expertise spans both front-end and back-end development, making him a rare gem in
                  the tech world.
                </p>
                <p>
                  His leadership has been instrumental in the successful design and deployment of
                  over 200 applications across diverse business sectors. Anas Madi 's ability to
                  simplify intricate processes and devise innovative solutions has left an indelible
                  mark on the global tech landscape.
                </p>
                <p>
                  But Anas Madi's contributions extend beyond Metachain. As a mentor to over 10,000
                  academy students, he's shaping the future of software development, nurturing the
                  next generation of tech innovators.
                </p>
                <p>
                  With a keen eye on the future, Anas Madi's data-driven strategies ensure
                  Metachain's continued growth and sustainability. His leadership style, marked by
                  adaptability and innovation, creates a vibrant work environment that propels
                  Metachain towards its ambitious goals.
                </p>
                <Link
                  className='d-flex hero-action gap-2 justify-content-center mt-3'
                  href={routes.anas}
                >
                  <button className='btn btn-primary home-btn'> Discover Anas's Journey</button>
                  <span className='arr-right-btn d-flex align-items-center justify-content-center position-relative'>
                    <BiRightArrowAlt />
                    <BiRightArrowAlt className='position-absolute' />
                  </span>
                </Link>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};

export default TeamMain;
